import React from 'react';
import PropTypes from 'prop-types';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { useTranslation } from 'react-i18next';
import lockIcon from 'assets/images/lock.png';
import tabletIcon from 'assets/images/tablet2.png';

import 'react-lazy-load-image-component/src/effects/opacity.css';
import rose from 'assets/images/rose.png';

const InfoScreen = ({ label, content, gif }) => {
  const isGifFormat = gif?.toLowerCase().endsWith('.gif');
  const { t } = useTranslation();
  const isPrivacyScreen = label?.toLowerCase().includes('privacy');

  return (
    <section className="info-screen-survey">
      <div className="question__gif">
        <LazyLoadImage 
          effect="opacity" 
          src={gif} 
          alt="this is a Gif" 
          width="100%" 
          style={{ 
            display: 'block',
            maxHeight: '320px',
            width: '100%',
            objectFit: 'cover',
            height: '100%'
          }} 
        />
        {!isGifFormat && 
          <div className={`question__gif-icon ${isPrivacyScreen ? 'privacy' : ''}`}>
            <img 
              src={isPrivacyScreen ? lockIcon : tabletIcon}
              alt={isPrivacyScreen ? "privacy icon" : "tablet icon"} 
            />
          </div>
        }
      </div>
      <div className='info-screen-survey-container'>
        <h2 className="info-screen-survey-title">{label}</h2>
        <p className="info-screen-survey-content">{content}</p>
        {isPrivacyScreen && (
          <div className='info-screen-survey-confidential'>
            <img src={rose} alt='rose' className='info-screen-confidential-icon'/>
            <p className='info-screen-confidential-text'>{t('evieOnboarding.quizStarter.confidential')}</p>
          </div>
        )}
      </div>
    </section>
  );
};

InfoScreen.propTypes = {
  label: PropTypes.string.isRequired,
  content: PropTypes.string.isRequired,
  gif: PropTypes.string.isRequired,
};

export default InfoScreen;
